import React from 'react';
import { NavLink } from 'react-router-dom';
import { Spring } from 'react-spring/renderprops';
import NumberFormat from 'react-number-format';

import LinkButton from 'components/LinkButton';
import BasicControlGroup from 'components/BasicControlGroup';
import BasicButtonGroup from 'components/BasicButtonGroup';
import BasicButton from 'components/BasicButton';
import PanelContainer from 'components/PanelContainer';
import BasicCheckbox from 'components/BasicCheckbox';

import { linkedInShareUrl } from 'helpers/share';
import { StringHelpers } from 'helpers/string-helpers';
import { LinkBuilder } from 'helpers/link-builder';
import { ANIMATION_TIMEOUT_INOUT } from 'constants/animation.js';

import './styles.css';

const SubscriptionProcessItem = props => {
  const { data, actions, isSelectable = false, isSelected = false } = props;
  const {
    applicants,
    ProcessID,
    Type,
    Descriptions,
    StartDate,
    PositionTitle,
    FirmName,
    AssignedFirmID,
    AssignedFirmName,
    AllowPush,
    Approved,
    BlockLinkedInSharing,
  } = data;

  const {
    handlePush,
    handleViewStatistics,
    handleViewApplicants,
    handleSelectChange,
  } = actions;

  const allowPush = parseInt(AllowPush) === 1;

  const onPush = () => {
    handlePush(data);
  };

  const onViewStatistics = () => {
    handleViewStatistics(data);
  };

  const onViewApplicants = () => {
    handleViewApplicants(data);
  };

  const onSelectChange = (name, value) => {
    handleSelectChange(ProcessID, !value);
  };

  const handleShare = () =>
    linkedInShareUrl(
      window.location.origin +
        LinkBuilder.getProcessPublicLink(
          data.Id,
          Type === 'Job' ? 'process' : 'project'
        )
    );

  const link = LinkBuilder.getSubscriptionJobLink(ProcessID);

  return (
    <Spring
      from={{ opacity: 0 }}
      to={{ opacity: 1 }}
      config={{ duration: ANIMATION_TIMEOUT_INOUT }}
    >
      {props => (
        <PanelContainer
          styles={(props, { paddingTop: '25px', marginBottom: '10px' })}
        >
          <div className="subscription-process-item">
            <div className="subscription-process-item__controls">
              {isSelectable && allowPush && (
                <div className="subscription-process-item__checkbox">
                  <BasicCheckbox
                    value={isSelected}
                    singleRow
                    checked={isSelected}
                    title=""
                    name="Selected"
                    wrapperStyles={{ height: 'auto' }}
                    onChange={onSelectChange}
                    labelStyles={{
                      fontFamily: 'Noto Sans, sans-serif',
                      fontSize: '0.9286rem',
                      margin: '5px 0',
                    }}
                  />
                </div>
              )}
              <BasicControlGroup>
                {BlockLinkedInSharing === 'No' && Approved === 'Yes' && (
                  <LinkButton
                    text="Share on LinkedIn"
                    controlFunc={handleShare}
                  />
                )}
                {allowPush && (
                  <LinkButton text={`Push ${Type}`} controlFunc={onPush} />
                )}
                <LinkButton text="Edit" to={`${link}/edit`} />
              </BasicControlGroup>
            </div>

            <div className="subscription-process-item__content">
              <div className="subscription-process-item__highlights">
                <div className="subscription-process-item__highlight">
                  <div className="subscription-process-item__block">
                    <div className="subscription-process-item__name">
                      Applications
                    </div>
                    <div className="subscription-process-item__value">
                      <NumberFormat
                        thousandSeparator
                        value={applicants}
                        displayType={'text'}
                      />
                    </div>
                  </div>
                </div>
                <div className="subscription-process-item__highlight">
                  <div className="subscription-process-item__block">
                    <div className="subscription-process-item__name">
                      Start Date
                    </div>
                    <div className="subscription-process-item__value">
                      {StartDate}
                    </div>
                  </div>
                </div>
                <div className="subscription-process-item__highlight">
                  <div className="subscription-process-item__block">
                    <div className="subscription-process-item__name">
                      Position
                    </div>
                    <div className="subscription-process-item__value">
                      {PositionTitle}
                    </div>
                  </div>
                </div>
              </div>
              <div className="subscription-process-item__description">
                {StringHelpers.trimString(Descriptions, 30, '... ')}
                <NavLink className="read-more-button" to={link}>
                  Read more
                </NavLink>
              </div>
            </div>

            <div className="subscription-process-item__assigned">
              <span className="subscription-process-item__firmname">
                {AssignedFirmID ? (
                  <>
                    Assigned to: <strong>{AssignedFirmName} </strong>
                  </>
                ) : (
                  <>
                    Owner: <strong>{FirmName} </strong>
                  </>
                )}
              </span>
            </div>

            <div className="proccess-item__footer">
              <BasicButtonGroup>
                {applicants > 0 && (
                  <BasicButton
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={600}
                    btnText="View Applicants"
                    btnArrow={false}
                    controlFunc={onViewApplicants}
                    btnBg="#fff"
                    btnHoverBg="#f40"
                  />
                )}

                {applicants > 0 && (
                  <BasicButton
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={600}
                    btnText="View Statistics"
                    btnArrow={false}
                    controlFunc={onViewStatistics}
                    btnBg="#fff"
                    btnHoverBg="#f40"
                  />
                )}
              </BasicButtonGroup>
            </div>
          </div>
        </PanelContainer>
      )}
    </Spring>
  );
};

export default SubscriptionProcessItem;
